import React, { useContext, useMemo, memo, useState } from "react";
import googleMapStyles from "helpers/googleMapStyles";
import AppContext from "context/Context";
import PropTypes from 'prop-types';

const MapWrapper = ({ children, height, width }) => {
    const [mapType, setMapType] = useState('hybrid');
    const { config: { isDark } } = useContext(AppContext);
    const mapStyle = useMemo(() => (isDark ? googleMapStyles.Midnight : googleMapStyles.Beard), [isDark]);

    return React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child;

        const existingOptions = child.props?.options || {};
        const newOptions = {
            ...existingOptions,
            styles: mapStyle,
            mapTypeControl: true,
            mapTypeId: mapType
        };

        return (
            <div className="shadow mt-4" style={{ height: height || '400px', width: width || '100%' }}>
                {React.cloneElement(child, {
                    ...child.props, onMapTypeIdChange: (mapTypeId) => setMapType(mapTypeId), options: newOptions
                })}
            </div>);
    });
};

MapWrapper.propTypes = {
    children: PropTypes.node,
    height: PropTypes.string,
    width: PropTypes.string
};

export default memo(MapWrapper);